import { z } from "zod";
import apiClient from "../../../shared/api/client";
import type { EmailTemplate } from "../types";

const emailTemplateSchema = z.object({
  id: z.string(),
  key: z.string(),
  name: z.string(),
  subject: z.string(),
  variables: z.array(z.string()),
  sampleData: z.record(z.string()),
  language: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

const emailTemplatesListSchema = z.array(emailTemplateSchema);

export const fetchEmailTemplates = async (): Promise<EmailTemplate[]> => {
  const response = await apiClient.get("/email-templates");
  return emailTemplatesListSchema.parse(response.data);
};

export const fetchEmailTemplatePreview = async (id: string): Promise<string> => {
  const response = await apiClient.get(`/email-templates/${id}/preview`, {
    responseType: "text",
    transformResponse: [(data: string) => data],
  });
  return response.data as string;
};
